import { Switch, Typography, Box, Grid } from "@mui/material";
import { useFormContext, useController } from "react-hook-form";
import { useSelector } from "react-redux";
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";

ToggleInput.propTypes = {
  fieldAttributes: PropTypes.object,
  fieldName: PropTypes.string,
}

export default function ToggleInput({ fieldAttributes, fieldName }) {
  const { control } = useFormContext();
  const { field } = useController({ name: fieldName, control });
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  // taken from mui's docs https://mui.com/material-ui/react-switch/
  const StyledSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 14,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.secondary.main,
          ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.secondary.main,
          }),
        },
      },
      '&.Mui-disabled': {
        '& + .MuiSwitch-track': {
          opacity: 1
        },
      }
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 10,
      height: 10,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
      backgroundColor: '#fff',
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.info.main,
      ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.info.main,
      }),
    },
  }));

  return (
    <Grid container direction="row" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Grid item>
        <Grid container direction="column" alignItems="start">
          <Grid item>
            <Typography
              variant="caption"
              color="text.secondary"
            >
              {fieldAttributes.label}
            </Typography>
          </Grid>
          <Grid item>
            <Box
              sx={{
                backgroundColor: 'rgba(167, 167, 167, 0.53)',
                opacity: !fieldAttributes.isEditable || isCanceled ? 0.6 : 1,
                borderRadius: 8,
                p: 0.3,
                width: 58,
                display: 'flex',
              }}
            >
              <Typography
                variant="caption"
                sx={{ fontWeight: 'bold', fontSize: 10, ml: 0.5, mr: 'auto' }}
                component="span"
                color="text.secondary"
              >
                {field?.value ? 'Yes' : 'No'}
              </Typography>
              <StyledSwitch
                disabled={!fieldAttributes.isEditable || isCanceled}
                checked={!!field?.value}
                inputProps={{ 'aria-label': 'ant design' }}
                //Firing onChange on onMouseDown so that toggle 
                //works on first click even when other fields are focused
                onMouseDown={() => field.onChange(!field.value) } 
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}